<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { useVModel } from '@vueuse/core'
//import { cn } from '~/utils/cn'

const props = defineProps<{
    class?: HTMLAttributes['class']
    defaultValue?: string | number
    modelValue?: string | number
    maxlength?: string | number
    rows?: string | number
}>()

const textareaRef = ref<HTMLTextAreaElement | null>(null);
defineExpose({
  textarea: textareaRef,
});

const emits = defineEmits<{
    (e: 'update:modelValue', payload: string | number): void
}>()

const modelValue = useVModel(props, 'modelValue', emits, {
    passive: true,
    defaultValue: props.defaultValue,
})
</script>

<template>
    <div class="relative w-full custom_width">
        <textarea ref="textareaRef" :maxlength="maxlength" v-bind="$attrs" v-model="modelValue" :rows="rows" class="ys_contacts_message "
            :class="cn('flex min-h-20 w-full rounded-md border border-neutral-200 bg-white px-3 py-2 text-sm ring-offset-white placeholder:text-neutral-500 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50', maxlength ? 'pb-12' : '', props.class)" />
        <span v-if="maxlength" class="absolute text-gray-400 ltr:text-right rtl:text-left left-[1px] right-[1px] bg-white py-0.5 px-1 bottom-[1px] rounded-md z-10 font-medium text-[11px]">
            {{ props.modelValue?.length ? props.modelValue.length : 0 }} / {{ props.maxlength }}
        </span>
    </div>
</template>

<style scoped lang="scss">
.ys_contacts_message {
    &:not(.scrollbar-none){
        &::-webkit-scrollbar {
            width: 3px;
        }

        &::-webkit-scrollbar-track {
            background: transparent;
        }

        &::-webkit-scrollbar-thumb {
            background: #f3f4f6;
            border-radius: 999px;
            transition: all .4s;
            border: 2px solid transparent;
        }

        &::-webkit-scrollbar-thumb:hover {
            background: #dbdcde;
        }
    }
    &.scrollbar-none{
        &::-webkit-scrollbar {
            display: none !important;
        }
    }
}
</style>